export default __webpack_public_path__ + "static/media/baby1.cbe28d3d.png";